import { BlackNumberCaseModel, CommonModel } from "src/app/core/models/shared/commone.model";

export const rednumbercase: BlackNumberCaseModel[] = [
  /* { "id": 1,'secId': 1, "name": "คดีหมายเลขแดงที่", },
  { "id": 21,'secId': 6, "name": "คดีหมายเลขแดงที่ ค.", },
  { "id": 13,'secId': 4, "name": "คดีหมายเลขแดงที่ ง.", },
  { "id": 9,'secId': 3, "name": "คดีหมายเลขแดงที่ บ.", },
  { "id": 26,'secId': 7, "name": "คดีหมายเลขแดงที่ พม.", },
  { "id": 17,'secId': 5, "name": "คดีหมายเลขแดงที่ ล.", },
  { "id": 5,'secId': 2, "name": "คดีหมายเลขแดงที่ ส.", },
  { "id": 37,'secId': 10, "name": "คดีไกล่เกลี่ยหมายเลขแดงที่ กก.", }, */

];